/* eslint-disable import/prefer-default-export */

export const HIDDEN_CATEGORIES = [
  'Hidden',
];

export const ALLOWED_ON_WORLD = 'World';